import Common from "../../Common";

const Creator = class extends Common {
	getWebullSubscriptions = (companyId: id) => this.get(`/company/${companyId}/creator/subscriptions`)
	getWebullServices = (companyId: id) => this.get(`/company/${companyId}/creator/services`)
}

export default Creator
